import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ContractData} from '../dashboard/interfaces/contract-data';
import {catchError} from 'rxjs/operators';

@Injectable()
export class PersistanceService implements ContractData{
  email: string = '';
  first_name: string = '';
  last_name: string = '';


  set(key: string, data: string): void {
    if (key && key.length > 0 && data && data.length > 0) {
      try {
        localStorage.setItem(key, JSON.stringify(data));
      } catch (e) {
        console.error('Error saving to localStorage', e);
      }
    }
  }

  get(key: string): string {
    if (key && key.length > 0) {
      try {
        let str: string | null;
        str = localStorage.getItem(key);
        if (str) {
          return JSON.parse(str);
        } else {
          return '';
        }
      } catch (e) {
        console.error('Error getting data from localStorage', e);
        return '';
      }
    } else {
      return '';
    }
  }

  getContractDataFromLocalstorage(): Observable<ContractData | null> {
    const response = new PersistanceService();

    response.email = this.get('userEmail');
    response.first_name = this.get('userFirstName');
    response.last_name = this.get('userLastName');

    return of(response)
      .pipe(
        catchError(() => of(null)),
      );
  }

}
